import { render, staticRenderFns } from "./collaborativeDone.vue?vue&type=template&id=74074ee0&scoped=true"
import script from "./collaborativeDone.vue?vue&type=script&lang=js"
export * from "./collaborativeDone.vue?vue&type=script&lang=js"
import style0 from "./collaborativeDone.vue?vue&type=style&index=0&id=74074ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74074ee0",
  null
  
)

export default component.exports